// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"style_CardContainer__9z1Cc","titleWrapper":"style_titleWrapper__4ovHD","title":"style_title__3rc3X"};